import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ben-card-with-image',
  templateUrl: './card-with-image.component.html',
  styleUrls: ['./card-with-image.component.scss']
})
export class CardWithImageComponent implements OnInit {
  @Input() image: number[];
  constructor() {
    console.log(this.image);
   }

  ngOnInit(): void {
  }

}
